













































import {Component, Prop, Vue} from 'vue-property-decorator'

/**
 * A text input that the sender can repeat, mirroring the "Add Social Network"
 * pattern in the CMS. Bound to a `string[]`; blank rows are kept in the model so
 * the seed row renders, and the parent drops them before submitting.
 */
@Component
export default class ContactRepeatableInput extends Vue {
  @Prop({type: Array, default: () => ['']}) value!: string[]
  @Prop({type: [String, Number], default: undefined}) maxlength?:
    | string
    | number
  @Prop({type: String, default: ''}) placeholder!: string
  @Prop({type: String, default: 'Add'}) addLabel!: string
  @Prop({type: String, default: 'Remove'}) removeLabel!: string
  @Prop({type: Boolean, default: false}) invalid!: boolean
  @Prop({type: Number, default: 10}) max!: number

  /** Always renders at least one row so an empty optional field is still usable. */
  get entries(): string[] {
    return this.value.length ? this.value : ['']
  }

  get canAdd(): boolean {
    return this.entries.length < this.max
  }

  update(index: number, value: string) {
    const next = [...this.entries]
    next[index] = value
    this.$emit('input', next)
  }

  add() {
    if (this.canAdd) {
      this.$emit('input', [...this.entries, ''])
    }
  }

  remove(index: number) {
    const next = this.entries.filter((_, i) => i !== index)
    this.$emit('input', next.length ? next : [''])
  }
}
